
export const ServiceWorkerMessageType = {
    getIsReady:                         'getIsReady',
    getEnabled:                         'getEnabled',
    setEnabled:                         'setEnabled',
    getCurrentEnabled:                  'getCurrentEnabled',
    getCacheState:                      'getCacheState',
    getCurrentCacheState:               'getCurrentCacheState',
    updateDataConfig:                   'updateDataConfig',
    deleteCache:                        'deleteCache',
    createNewCache:                     'createNewCache',
    getNewCacheState:                   'getNewCacheState',
    applyChanges:                       'applyChanges',
    postMessageToClients:               'postMessageToClients',
};

export const ServiceWorkerClientMessageType = {
    onEnableStateChanged:               'onEnableStateChanged',
    onCurrentEnableStateChanged:        'onCurrentEnableStateChanged',
    onCacheStateChanged:                'onCacheStateChanged',
    onNewCacheStateChanged:             'onNewCacheStateChanged'
};

export const ServiceWorkerCacheState = {
    notInitialized:                     'notInitialized',
    none:                               'none',
    invalid:                            'invalid',
    valid:                              'valid',
    needsUpdate:                        'needsUpdate',
};

export const ServiceWorkerNewCacheState = {
    none:                               'none',
    creating:                           'creating',
    ready:                              'ready'
};

export const ServiceWorkerResultType = {
    ok:                                 'ok',
    errorNotReady:                      'errorNotReady',
    errorNetwork:                       'errorNetwork',
    errorDataCorrupt:                   'errorDataCorrupt',
    errorInvalidArguments:              'errorInvalidArguments',
    errorCouldNotOpenKVStore:           'errorCouldNotOpenKVStore',
    errorCacheManager:                  'errorCacheManager',
    errorUnsupportedDataConfigModel:    'errorUnsupportedDataConfigModel',
    errorCouldNotOpenCache:             'errorCouldNotOpenCache',
    errorCouldNotDeleteCache:           'errorCouldNotDeleteCache',
    errorCouldNotCreateCache:           'errorCouldNotCreateCache',
    errorReadKVStore:                   'errorReadKVStore',
    errorWriteKVStore:                  'errorWriteKVStore',
    errorNoDataConfig:                  'errorNoDataConfig',
    errorCacheNotValid:                 'errorCacheNotValid',
    errorExceededStorage:               'errorExceededStorage',
    errorCachePutFailed:                'errorCachePutFailed',
    errorCacheAlreadyExists:            'errorCacheAlreadyExists',
    errorUnexpected:                    'errorUnexpected'
};